import trendingProduct from "./components/trending-products.js";

document.addEventListener("DOMContentLoaded", () => {
  trendingProduct().init();
});
